/**
 * An old `/prospector` address that reached the router: sent on to the page's
 * new address with its query and hash, or Page not found when it names no page.
 *
 * A page load of one never gets here, because the gateway answers it with a
 * 308 first (apps/api/src/lib/prospecting-gateway.ts). This is for a link
 * inside the app that still names one: an older message in the inbox, a
 * handbook line, a page not ported yet. Both read the one table in
 * `@gojibasel/shared/prospecting-paths`, so they cannot disagree.
 *
 * Always `replace`, so Back does not return to an address that only bounces.
 */
import { Navigate, useLocation } from 'react-router-dom'
import { legacyProspectingTarget } from '@gojibasel/shared/prospecting-paths'
import NotFound from '../../NotFound'

/** Where an old address lands inside the app, hash included, or null. */
export function legacyLanding(location: { pathname: string; search: string; hash: string }): string | null {
  const target = legacyProspectingTarget(location.pathname, location.search)
  return target === null ? null : `${target}${location.hash}`
}

export function LegacyProspectingRedirect() {
  const location = useLocation()
  const target = legacyLanding(location)
  return target === null ? <NotFound /> : <Navigate to={target} replace />
}
